import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import Login from './views/pages/login/Login'
import { CSpinner } from '@coreui/react'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  useEffect(() => {
    window.process = {
      ...window.process,
    }
  }, [])
  return (
    <HashRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}
/*
   // <BrowserRouter>
    //   <React.Suspense fallback={loading}>
    //     <Routes>
    //       <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
    //       <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
    //       <Route path="*" name="Home" element={<DefaultLayout />} />
    //     </Routes>
    //   </React.Suspense>
    // </BrowserRouter>
*/
export default App
